/** How a drill question is shown: read, heard, or both. */
export type NormalizedDisplayMethod =
  'Reading' | 'Hearing' | 'Reading And Hearing';

/** Maps the CMS spellings of a display method to one value (unknown → null). */
export function normalizeDisplayMethod(
  value?: string | null,
): NormalizedDisplayMethod | null {
  if (!value) return null;
  if (value === 'Reading' || value === 'Hearing') return value;
  if (value === 'Reading and Hearing') return 'Reading And Hearing';
  if (value === 'Reading_And_Hearing') return 'Reading And Hearing';
  if (value === 'Reading And Hearing') return value;
  return null;
}
